module.exports = __webpack_public_path__ + "img/logo-hoopla.dea775dc.jpg";